var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-Style-Guide",
    transform: "translate(-490.000000, -1688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ask-Question-Copy-2",
    transform: "translate(248.000000, 1672.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274,0.5 C274.966498,0.5 275.841498,0.891750844 276.474874,1.52512627 C277.108249,2.15850169 277.5,3.03350169 277.5,4 L277.5,4 L277.5,419 C277.5,419.966498 277.108249,420.841498 276.474874,421.474874 C275.841498,422.108249 274.966498,422.5 274,422.5 L274,422.5 L4,422.5 C3.03350169,422.5 2.15850169,422.108249 1.52512627,421.474874 C0.891750844,420.841498 0.5,419.966498 0.5,419 L0.5,419 L0.5,4 C0.5,3.03350169 0.891750844,2.15850169 1.52512627,1.52512627 C2.15850169,0.891750844 3.03350169,0.5 4,0.5 L4,0.5 Z",
    id: "Rectangle-Copy-8",
    stroke: "#D9D9D7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cross-Circle/Solid-X",
    transform: "translate(242.000000, 16.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3924214,16.4585579 C20.2025262,17.268656 20.2025262,18.581665 19.3924214,19.3924265 C18.5823167,20.2025245 17.2686333,20.2025245 16.4585286,19.3924265 L10.0002488,12.9342003 L3.54130556,19.3924265 C2.73120081,20.2025245 1.41818091,20.2025245 0.608076167,19.3924265 C-0.202692056,18.581665 -0.202692056,17.268656 0.608076167,16.4585579 L7.06635594,10.0003317 L0.608076167,3.54144205 C-0.202692056,2.73134403 -0.202692056,1.41767155 0.608076167,0.607573521 C1.41818091,-0.202524507 2.73120081,-0.202524507 3.54130556,0.607573521 L10.0002488,7.0664632 L16.4585286,0.607573521 C17.2686333,-0.202524507 18.5823167,-0.202524507 19.3924214,0.607573521 C20.2025262,1.41767155 20.2025262,2.73134403 19.3924214,3.54144205 L12.9341417,10.0003317 L19.3924214,16.4585579 Z",
    id: "Cross-Circle/Solid",
    transform: "translate(10.000000, 10.000000) rotate(-360.000000) translate(-10.000000, -10.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.29a70869f3ad0c04e63703e1147886f7.svg";
export { ForwardRef as ReactComponent };